import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

export default class extends Controller {
  static values = {
    debounce: { type: Number, default: 100 }
  }

  static debounces = ["submit"]

  connect() {
    useDebounce(this, { wait: this.debounceValue })
  }

  disconnect() {
    this.submit.cancel?.()
  }

  submit(event) {
    event.preventDefault()

    const target = event?.target ?? this.element
    if (!target || target.disabled || target.readOnly) return

    const form =
      target.form || target.closest("form") || this.element.closest("form")
    form?.requestSubmit()
  }
}
